import { Component } from '@angular/core';
import {
    PlatformService, LoggingService, TokenService, LocalStorageService, NotificationsService,
    PriceService, EventTicketsResponse
} from '@varsity/services';
import { BaseComponent } from '@varsity/components';
import { PopoverController, ToastController, NavParams, ViewController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { DomSanitizer } from '@angular/platform-browser';
/**
 * Generated class for the DisplayMessageComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'stadium-section-map-popover',
    templateUrl: 'stadium-section-map-popover.html'
})
export class StadiumSectionMapPopoverComponent extends BaseComponent {
    eventID: number;
    sponsorID: number;
    promoCode: string;
    buttons: { text: string, tag: string, icon: string }[];
    stadiumLayout: EventTicketsResponse;
    selectedSectionDetails: { level: string, section: string, priceRating: string };
    packageDetails: { hasPackages: boolean, seasonPassId: string };

    constructor(
        protected platformService: PlatformService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected priceService: PriceService,
        protected popoverCtrl: PopoverController,
        protected toastCtrl: ToastController,
        protected viewCtrl: ViewController,
        protected navParams: NavParams,
        protected iab: InAppBrowser,
        protected sanitizer: DomSanitizer
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "StadiumSectionMapPopoverComponent"
        );
    }

    ngOnInit() {
        this.eventID = parseInt(this.navParams.get('eventID'));
        this.sponsorID = parseInt(this.navParams.get('sponsorID'));
        this.promoCode = this.navParams.get('promoCode');
        this.buttons = this.navParams.get('buttons');
        this.stadiumLayout = this.navParams.get('stadiumLayout');
        this.selectedSectionDetails = this.navParams.get('selectedSectionDetails');
        this.packageDetails = this.navParams.get('packageDetails');
    }

    buttonClicked(button: { text: string, tag: string }) {
        this.viewCtrl.dismiss({
            button
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/stadium-section-map-popover/stadium-section-map-popover.ts